import { useId, useState, type ReactNode } from "react";
import { Icon } from "../icons/Icon";

/**
 * El DESPLEGABLE del sistema (`sk-disclose`, 2026-10-26): un mando de texto
 * con chevrón que gira (`aria-expanded`) y la región que gobierna
 * (`aria-controls`), oculta hasta abrirla. Es la misma pieza que el «qué
 * cubre» de `Cover`, suelta para otros sitios — p. ej. el puente de un
 * episodio en el inspector del Studio (ADR-21, 2026-11-03).
 */
export function Disclose({ act, children, defaultOpen = false }: { act: ReactNode; children: ReactNode; defaultOpen?: boolean | undefined }) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <>
      <button type="button" className="sk-disclose" aria-expanded={open} aria-controls={id} onClick={() => setOpen((o) => !o)}>{act} <Icon name="chevron-r" /></button>
      <div id={id} hidden={!open}>{children}</div>
    </>
  );
}
